/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import MuiDialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

import stylesCss from "./index.module.css";
import classNames from "classnames";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { useSelector } from "react-redux";
import { ArrowBack } from "@material-ui/icons";
import { selectLoadingUI } from "../../reducers/uiSlice";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    minHeight: 350,
  },
}))(MuiDialogContent);

const Dialog = withStyles((theme) => ({
  root: {
    margin: 5,
    padding: theme.spacing(1),
    // minWidth: 250,
  },
  paper: {
    width: 480,
    minHeight: 350,
    padding: theme.spacing(1),
    margin: "0 auto",
    backgroundColor: "#122526",
  },
}))(MuiDialog);

const DialogActions = withStyles((theme) => ({
  root: {},
}))(MuiDialogActions);

export default function ColorPopup({
  show,
  handleClose,
  handleSave,
  content,
  title = "Configuración de los colores",
}) {
  const loading = useSelector(selectLoadingUI);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div>
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={show}
        fullScreen={fullScreen}
        maxWidth={"md"}
        onClose={(e) => handleClose()}
      >
        <DialogTitle id="customized-dialog-title">
          <h5 className={stylesCss.back} onClick={() => handleClose()}>
            <ArrowBack /> Regresar
          </h5>
        </DialogTitle>
        <DialogContent
          style={{ textAlign: "left", display: "flex", position: "relative" }}
        >
          <div className="row">
            <div className="col-12">
              <h4 className={stylesCss.title}>{title}</h4>
            </div>
            <div className="col-12">{content}</div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            style={{
              width: 180,
              height: 40,
              margin: "17px 25px 17px 15px",
            }}
            disabled={loading}
            onClick={() => handleClose()}
            className={classNames("btn", "blueEditionCancelButton2")}
          >
            <h6
              style={{ fontSize: 14 }}
              className={"blueEditionCancelButtonText2"}
            >
              Cancelar
            </h6>
          </Button>
          <Button
            style={{
              width: 180,
              height: 40,
              margin: "17px auto 17px 25px",
            }}
            disabled={loading}
            onClick={() => handleSave()}
            className={classNames("btn", "blueEditionSaveButton2")}
          >
            <h6
              className={"blueEditionSaveButtonText2"}
              style={{ fontSize: 14 }}
            >
              Asignar color
            </h6>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
